import React from "react";
import styled from "styled-components";
import productLogoSvg from "assets/images/logoRegistration2024.png";
import whiteProductLogo from "assets/images/whiteProductLogo.svg";
import srpProductLogo from "assets/images/srp2025.png";
import tippingProductLogo from "assets/images/tipping2024.png";
import srp30yearProductLogo from "assets/images/SRP_30Y.png";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 25px;

	img {
		max-width: 250px;

		&:first-child {
			margin-bottom: 11px;
		}
	}

	@media (min-width: 769px) {
		margin-bottom: 45px;

		img {
			max-width: 320px;
		}
	}
`;

export const ProductLogo = styled.div<{$isLanding?: boolean}>`
	background-image: url(${({$isLanding}) => ($isLanding ? whiteProductLogo : productLogoSvg)});
	background-repeat: no-repeat;
	background-size: contain;
	background-position-x: center;
	width: 250px;
	height: ${({$isLanding}) => ($isLanding ? 115 : 90)}px;
	margin-bottom: 5px;

	@media (min-width: 769px) {
		width: 320px;
		height: 150px;
		background-image: url(${srpProductLogo});
	}
`;
const ImageWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 20px;
	align-items: center;
	max-height: 100px;
	margin-bottom: 20px;
	margin: 20px auto 10px;
	.product-logo {
		height: 100px;
		max-height: 100px;

		width: auto;
	}
	.mobile-product-logo {
		display: none;
	}
	@media (max-width: 640px) {
		flex-direction: column;
		.product-logo {
			display: none;
		}
		.mobile-product-logo {
			display: block;
			height: 80px;
			margin: 10px 0;
		}
	}
`;
interface IBanner {
	isLanding?: boolean;
}

export const Banner: React.FC<IBanner> = ({isLanding}) => (
	<Wrapper>
		<ImageWrapper>
			<img className="product-logo" src={tippingProductLogo} alt="Tipping Logo" />
			<img
				className="product-logo"
				src={srp30yearProductLogo}
				alt="Super Rugby Pacific 30 Year Logo"
			/>
			<img
				className="product-logo"
				src={srpProductLogo}
				height={"100%"}
				alt="Super Rugby Pacific Logo"
			/>

			<img
				className="mobile-product-logo"
				src={srp30yearProductLogo}
				alt="Super Rugby Pacific 30 Year Logo"
			/>
		</ImageWrapper>
	</Wrapper>
);

export * from "./LeaderBoard";
